import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs/Rx";
import {UserService} from "@catcore/services/user.service";
import {CatUser} from "@catcore/types/api-v2";
import {RxWebsocketSubject} from "@catcore/types/rx-websocket-subject";

@Injectable()
export class ServerNotificationService {
  public messages: RxWebsocketSubject<any>;

  public visibleState: Subject<boolean>;
  public signalProcessStart: Subject<boolean>;

  protected userId;

  protected userName;

  protected connected;

  constructor(private userService: UserService) {
    const serverUrl = ServerNotificationService.getServerUrl();
    this.visibleState = new Subject<boolean>();
    this.signalProcessStart = new Subject<boolean>();
    this.connected = false;
    this.messages = new RxWebsocketSubject(serverUrl);

    this.messages.connectionStatus.subscribe((isConnected) => {
      console.log('Websocket connected: ', isConnected);
      this.connected = isConnected;
      if (isConnected && this.userName) {
        console.log('(Re)connect. Sending username: ', this.userName);
        this.messages.send({username: this.userName});
      }
    });

    this.userService.getUser().subscribe((user: CatUser) => {
      this.userName = user.name;
      console.log('User logged in. Sending username: ', this.userName);
      if (!this.isConnected()) {
        this.connect();
      } else {
        this.messages.send({username: this.userName});
      }
    });
    this.userService.refresh();
  }

  isConnected() {
    return this.connected;
  }

  connect() {
    if (!this.connected) {
      this.messages.connect();
    }
  }

  show() {
    this.visibleState.next(true);
  }

  hide() {
    this.visibleState.next(false);
  }

  getUserId() {
    return this.userId;
  }

  signalProcessAboutToStart() {
    this.show();
    this.signalProcessStart.next(true);
  }

  private static getServerUrl() {
    const loc = window.location;
    let serverUrl;
    if (loc.protocol === "https:") {
      serverUrl = "wss:";
    } else {
      serverUrl = "ws:";
    }
    serverUrl += "//" + loc.host + "/ws";
    return serverUrl;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/server-notification.service.ts